import { InitConfig, EventType } from './types';
import { Core, IConfig } from '@roai/core';
import { v4 as uuidv4 } from 'uuid';
import { isLocalStorageSupported } from '@roai/shared';
import memoryStorage from '@roai/core/src/db/memory';
import { reportCrash, reportError } from '@roai/core/src/monitor';
import { Injectable, DIContainer, Inject } from '@roai/framework';

let localEnv = '';
const bizType = 'carty-ad-creative';

@Injectable('Config')
export class Config implements IConfig {
  endpoints = {
    report: '/sdk/tracking/report-pb',
    publicKey: '/sdk/tracking/public-key',
  }
  bizType = bizType
  get storage() {
    return isLocalStorageSupported() ? localStorage : memoryStorage;
  }
  get origin() {
    return localEnv == 'google' ? __GOOGLE_ORIGIN__ : __OTHER_ORIGIN__;
  }
}

@Injectable()
class TrackingSdk {
  private isRunning: boolean = false;
  private params: Record<string, string> = {};
  private preEventId: string = '';

  constructor(@Inject() private core: Core) {}

  /**
   * 启动 SDK
   */
  public initSdk({ gdpr = false, data = {}, onError = () => {}, env = 'google' }: InitConfig): void {
    if (this.isRunning) return;
    window.__n_host__ = env === 'google' ? __GOOGLE_ORIGIN__ : __OTHER_ORIGIN__;
    try {
      localEnv = env;
      this.isRunning = true;
      this.params = data;
      this.core.init(gdpr);
    } catch (e) {
      onError('internal error');
      reportCrash({
        stackTrace: e.stack || e.message,
        customData: {
          _$: 'initSdk',
          gdpr,
          ...data,
        }
      });
    }
  }

  /**
   * 停用 SDK
   */
  public stop() {
    this.isRunning = false; 
    this.core.stop();
  }

  /**
   * 
   * 事件上报
   */
  public trackEvent(type: EventType, payload?: Record<string, string>) {
    reportError({
      logType: 'analytics',
      bizType,
      logName: 'track-' + type,
      params: {},
    });
    try {
      const eventId = uuidv4();
      const eventData = {
        ...payload,
        preEventId: this.preEventId,
        eventId,
        eventType: type,
      }
      this.core.sendData(this.params, eventData);
      this.preEventId = eventId;
      return {
        success: true,
        eventId,
      }
    } catch (e) {
      reportError({
        logType: 'error',
        bizType,
        logName: 'track-error',
        params: {},
      });
      return {
        success: false,
        eventId: '',
      }
    }
  }
}

const container = DIContainer.getInstance();
const sdk = container.resolve<TrackingSdk>(TrackingSdk)
export default sdk;
